// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBkN9zasbp6jjHlDVygZwTbzFmFiopkuFU",
    authDomain: "activehearing-5cf44.firebaseapp.com",
    databaseURL: "https://activehearing-5cf44.firebaseio.com",
    projectId: "activehearing-5cf44",
    storageBucket: "activehearing-5cf44.appspot.com",
    messagingSenderId: "556146136347",
    appId: "1:556146136347:web:6aee6033f032d70e"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
